import {
  Component,
  AfterViewInit,
  Input,
  OnDestroy
} from '@angular/core';

@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss']
})
export class MainContentComponent implements AfterViewInit, OnDestroy {
  @Input() title!: string;
  constructor() {}
  ngOnDestroy(): void {}
  ngAfterViewInit() {}

}
